export const DELETE_FILE_SUCCEEDED = 'DELETE_FILE_SUCCEEDED';
export const DELETE_FILE_FAILED = 'DELETE_FILE_FAILED';
export const DELETE_FILE = 'DELETE_FILE';
export const POST_FILE_SUCCEEDED = 'POST_FILE_SUCCEEDED';
export const POST_FILE_FAILED = 'POST_FILE_FAILED';
export const POST_FILE = 'POST_FILE';
